var map = {
	"./Animadversion-Laura-Candela.jpg": 922,
	"./Ascenso-A-La-Fama-Laura-Candela.jpg": 577,
	"./Namaste-Laura-Candela.jpg": 255,
	"./Royonoir-Laura-Candela.jpg": 0,
	"./Tres-Mujeres-Laura-Candela.jpg": 185
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 507;